import {
  StyledStripeConfigIcon,
  StyledMessageConfigIcon,
  StyledHabitConfigIcon,
  StyledCheckInConfigIcon,
  StyledCheckoutPageConfigIcon,
  StyledProductConfigIcon,
  StyledProfileIcon,
  StyledSettingsIcon,
  StyledNotificationIcon,
  StyledInstagramIcon,
} from './styles';

import texts from './texts.json';

const ConfigurationType = {
  HABITS: 'HABITS',
  PAYMENT: 'PAYMENT',
  CHECKOUT_PAGE: 'CHECKOUT_PAGE',
  WELCOME_MESSAGE: 'WELCOME_MESSAGE',
  LIBRARY_DOCUMENTS: 'LIBRARY_DOCUMENTS',
  ONBOARDING_MESSAGES: 'ONBOARDING_MESSAGES',
  CLIENT_JOURNEY_WEEKLY_MESSAGE: 'CLIENT_JOURNEY_WEEKLY_MESSAGE',
  CHECK_IN: 'CHECK_IN',
  PRODUCTS: 'PRODUCTS',
  PROFILE_SETTINGS: 'PROFILE_SETTINGS',
  NOTIFICATION_SETTINGS: 'NOTIFICATION_SETTINGS',
  INSTAGRAM_SETTINGS: 'INSTAGRAM_SETTINGS',
  OTHER_SETTINGS: 'OTHER_SETTINGS',
  AI_PROMPT_SETTINGS: 'AI_PROMPT_SETTINGS',
  CHECK_IN_FEEDBACK_SETTINGS: 'CHECK_IN_FEEDBACK_SETTINGS',
  FORM_SETTINGS: 'FORM_SETTINGS',
  BIRTHDAY_MESSAGE: 'BIRTHDAY_MESSAGE',
  UPSELL_SETTINGS: 'UPSELL_SETTINGS',
};

const configurationPagesConfig = {
  [ConfigurationType.PAYMENT]: {
    id: ConfigurationType.PAYMENT,
    title: texts.paymentSettings,
    icon: StyledStripeConfigIcon,
    path: 'payment',
  },
  [ConfigurationType.HABITS]: {
    id: ConfigurationType.HABITS,
    title: texts.HABITS,
    icon: StyledHabitConfigIcon,
    path: 'habits',
  },
  [ConfigurationType.CHECK_IN]: {
    id: ConfigurationType.CHECK_IN,
    title: texts.CHECK_IN,
    icon: StyledCheckInConfigIcon,
    path: 'check-in',
  },
  [ConfigurationType.CHECKOUT_PAGE]: {
    id: ConfigurationType.CHECKOUT_PAGE,
    title: texts.CHECKOUT_PAGE,
    icon: StyledCheckoutPageConfigIcon,
    path: 'checkoutPage',
  },
  [ConfigurationType.WELCOME_MESSAGE]: {
    id: ConfigurationType.WELCOME_MESSAGE,
    title: texts.WELCOME_MESSAGE,
    icon: StyledMessageConfigIcon,
    path: 'welcomeMessage',
  },
  [ConfigurationType.LIBRARY_DOCUMENTS]: {
    id: ConfigurationType.LIBRARY_DOCUMENTS,
    title: texts.LIBRARY_DOCUMENTS,
    icon: StyledMessageConfigIcon,
    path: 'libraryDocuments',
  },
  [ConfigurationType.ONBOARDING_MESSAGES]: {
    id: ConfigurationType.ONBOARDING_MESSAGES,
    title: texts.ONBOARDING_MESSAGES,
    icon: StyledMessageConfigIcon,
    path: 'onboardingMessages',
  },
  [ConfigurationType.CLIENT_JOURNEY_WEEKLY_MESSAGE]: {
    id: ConfigurationType.CLIENT_JOURNEY_WEEKLY_MESSAGE,
    title: texts.CLIENT_JOURNEY_WEEKLY_MESSAGE,
    icon: StyledMessageConfigIcon,
    path: 'clientJourneyWeeklyMessage',
  },
  [ConfigurationType.PRODUCTS]: {
    id: ConfigurationType.PRODUCTS,
    title: texts.productsPricing,
    icon: StyledProductConfigIcon,
    path: 'products',
  },
  [ConfigurationType.PROFILE_SETTINGS]: {
    id: ConfigurationType.PROFILE_SETTINGS,
    title: texts.profileSettings,
    icon: StyledProfileIcon,
    path: 'profileSettings',
  },
  [ConfigurationType.NOTIFICATION_SETTINGS]: {
    id: ConfigurationType.NOTIFICATION_SETTINGS,
    title: texts.notificationSettings,
    icon: StyledNotificationIcon,
    path: 'notificationSettings',
  },
  [ConfigurationType.INSTAGRAM_SETTINGS]: {
    id: ConfigurationType.INSTAGRAM_SETTINGS,
    title: texts.instagramSettings,
    icon: StyledInstagramIcon,
    path: 'instagramSettings',
  },
  [ConfigurationType.OTHER_SETTINGS]: {
    id: ConfigurationType.OTHER_SETTINGS,
    title: texts.otherSettings,
    icon: StyledSettingsIcon,
    path: 'otherSettings',
  },
  [ConfigurationType.AI_PROMPT_SETTINGS]: {
    id: ConfigurationType.AI_PROMPT_SETTINGS,
    title: texts.aiPromptSettings,
    icon: StyledSettingsIcon,
    path: 'aiPromptSettings',
  },
  [ConfigurationType.CHECK_IN_FEEDBACK_SETTINGS]: {
    id: ConfigurationType.CHECK_IN_FEEDBACK_SETTINGS,
    title: texts.checkInFeedbackSettings,
    icon: StyledCheckInConfigIcon,
    path: 'checkInFeedbackSettings',
  },
  [ConfigurationType.FORM_SETTINGS]: {
    id: ConfigurationType.FORM_SETTINGS,
    title: texts.formSettings,
    icon: StyledSettingsIcon,
    path: 'formSettings',
  },
  [ConfigurationType.BIRTHDAY_MESSAGE]: {
    id: ConfigurationType.BIRTHDAY_MESSAGE,
    title: texts.BIRTHDAY_MESSAGE,
    icon: StyledMessageConfigIcon,
    path: 'birthdayMessage',
  },
  [ConfigurationType.UPSELL_SETTINGS]: {
    id: ConfigurationType.UPSELL_SETTINGS,
    title: texts.upsellSettings,
    icon: StyledProductConfigIcon,
    path: 'upsellSettings',
  },
};

export { ConfigurationType, configurationPagesConfig };
